export enum CompanionOperation {
  ADD = 'add',
  DELETE = 'delete',
  UPDATE = 'update',
}

export enum CompanionRole {
  JOB_OFFER_CREATION = 'job_offer_creation',
  SUPPORT = 'support',
  TALENTPOOL_SEARCH = 'talentpool_search',
}